<template>
  <div>
    <h2>Email Content</h2>
    <p>Edit the content sent in confirmation emails, use the attribute tool to add in variable values. These will be
      replaced by actual values in the email</p>
    <div class="flex">
      <label for="add-content">
        <select id="add-content" v-model="attribute">
          <option value="null" disabled>Select an attribute</option>
          <option value="[first-name]">First Name</option>
          <option value="[family-name]">Family Name</option>
          <option value="[email-address]">Email Address</option>
          <option value="[phone-number]">Phone Number</option>
          <option value="[cover-date]">Cover Date</option>
          <option value="[plan-name]">Plan Name</option>
          <option value="[monthly-amount]">Monthly Amount</option>
          <option value="[discount-code]">Discount code</option>
          <option value="[upcost]">Upcost</option>
          <option value="[fuel-type]">Fuel Type</option>
          <option value="[property-ownership]">Property Ownership Type</option>
          <option value="[guarantee-answer]">Guarantee Answer</option>
        </select>
      </label>
      <button @click.prevent="add" class="add-button">Add attribute</button>
    </div>

    <label for="email-content" class="form-input">
      <span>Email Content</span>
      <textarea id="email-content" v-model="content" rows="25"></textarea>
    </label>
    <button @click.prevent="submit" class="submit-button">Update content</button>
    <p class="error" v-if="error" v-html="error"></p>
  </div>
</template>

<script>
export default {
  name: "EmailMaker",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      content: '',
      attribute: '[first-name]',
      error: '',
    }
  },
  mounted(){
    this.getContent();
  },
  methods: {
    submit() {
      this.$axios.post(`${this.base}/api/emails/update.php`, this.$makeForm({ content: this.content }))
          .then((response) => {
            if (response.data === "saved") {
              this.$emit('save');
            } else {
              this.error = response.data;
            }
          });
    },
    getContent(){
      this.$axios.get(`${this.base}/api/emails/get.php`)
          .then((response) => {
            this.content = response.data;
          });
    },
    add() {
      this.content += this.attribute;
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  width: 50%;
}

.form-input {
  width: 100%;
  margin: 1rem 0;
  display: block;

  span, input[type=text], textarea {
    width: 100%;
    display: block;
  }

  span {
    margin-bottom: 0.5rem;
  }

  &.half {
    width: 40%;
    margin-right: 5%;
    display: inline-block;
  }
}

.add-button {
  background-color: #005EAE;
  color: #FFF;
  border-radius: 5px;
  padding: 0.3rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;
  margin-left: 0.4rem;
}

.flex {
  display: flex;
  align-items: center;
}

.form-checkbox {
  margin: 1rem 1rem 1rem 0;
  display: inline-flex;

  span, input {
    align-self: center;
  }

  span {
    margin-left: 0.4rem;
  }
}

.submit-button {
  display: block;
  margin: 1rem 0;
  background-color: #005EAE;
  color: #FFF;
  border-radius: 5px;
  padding: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: #004885;
    transition: 0.2s;
  }
  .btn-icon{
    width: 1rem;
    height: 1rem;
  }
}

.error {
  color: red;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/EmailMaker.vue